export const navigationMixin = {
  methods: {
    generateQueryParams: function (params) {
      return Object.keys(params)
        .map(function (p) {
          if (!params[p] || params[p].length === 0) {
            return null
          } else {
            let value = params[p]
            if (Array.isArray(value)) {
              value = value.join(',')
            }
            return encodeURIComponent(p) + '=' + encodeURIComponent(value)
          }
        })
        .filter(function (value) {
          return !!value
        })
        .join('&')
    },
    pushUrlState: function (query) {
      window.history.pushState(query, null, window.location.href.split('?')[0].concat('?').concat(query))
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/navigation.js